import { render, staticRenderFns } from "./Monitors-Results-Placeholder.vue?vue&type=template&id=0ffec7d8&lang=pug"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports